module.exports = __webpack_public_path__ + "assets/img/tab2_05.dbe435d0.jpg";